import { render, staticRenderFns } from "./swipeout.vue?vue&type=template&id=50f26f5a&scoped=true&"
import script from "./swipeout.vue?vue&type=script&lang=ts&"
export * from "./swipeout.vue?vue&type=script&lang=ts&"
import style0 from "./swipeout.vue?vue&type=style&index=0&id=50f26f5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f26f5a",
  null
  
)

export default component.exports